<div id="registrierungSeitenleisteInfo">
  <button
    *ngIf="mandant.darstellungRegistrierung == 2"
    id="formularAbbrechen"
    (click)="formularAbbrechen()"
    class="form-btn"
  ><mat-icon>delete</mat-icon><span>Registrierung verwerfen</span></button>
  <div id="kontaktDaten" [innerHTML]="mandant.betreiberDaten.kontakt"></div>
</div>
